import { fetch, key, trans } from "../../lib/utils";
import React from "react";
import { Component } from "react";
import { Form } from "@formio/react";
import { FormBuilder } from "@formio/react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

class Form1 extends Component {
  constructor(props) {
    super(props);

    this.submitForm = this.submitForm.bind(this);
    this.state = {
      loaded: false,
    };
  }
  // const [featureProperties, setFeatureProperties] = useState({});
  // const [formComponents, setFormComponents] = useState([]);
  // const [submissionData, setSubmissionData] = useState([]);

  // const formRef = useRef();

  // onchange = (property, value) => {
  //   let properties = { ...featureProperties };

  //   properties[property] = value;

  //   setFeatureProperties(properties);
  // };

  // useEffect(() => {
  //   console.log("Asdasdasd");
  //   // fetch(
  //   //   window["appConfig"]()["api"](
  //   //     "?proxy=raw&contenttype=".concat(
  //   //       "application/json",
  //   //       "&url=https://eleonas.getmap.gr/formio/form/65203cd1dbf0c0c5bf9b0a1a/"
  //   //     )
  //   //   ),
  //   //   "GET",
  //   //   {},
  //   //   null,
  //   //   (resp) => {
  //   //     console.log(resp.data);
  //   //     // setFormComponents(resp.data);
  //   //   }
  //   // );
  // }, []);

  componentDidMount() {
    console.log(this.props);
    let _this = this;
    fetch(
      window["appConfig"]()["api"](
        "?proxy=raw&contenttype=".concat(
          "application/json",
          "&url=https://eleonas.getmap.gr/formio/form/65203cd1dbf0c0c5bf9b0a1a/"
        )
      ),
      "GET",
      {},
      null,
      (resp) => {
        _this.setState({ loaded: true, form: resp.data });
      }
    );
  }

  submitForm(e) {
    let _this = this;
    console.log(e);
    fetch(
      window["appConfig"]()["api"](
        "?proxy=proxy&contenttype=".concat(
          "application/json",
          "&url=https://eleonas.getmap.gr/formio/form/65203cd1dbf0c0c5bf9b0a1a/submission/"
        )
      ),
      "POST",
      {},
      { data: e.data },
      (resp) => {
        _this.setState({ loaded: true, form: resp.data });
      }
    );
  }

  render() {
    if (this.state.loaded) {
      return (
        <div className="mt-2 p-2 me-3">
          <div className="mt-2">
            <p className="small">
              Προσθέστε στον χάρτη 3 σημεία προτεινόμενων παρεμβάσεων
            </p>
          </div>
          <div className="mt-2">
            <PerfectScrollbar style={{ height: "calc(100vh - 25rem)" }}>
              <Form form={this.state.form} onSubmit={this.submitForm} />
            </PerfectScrollbar>
          </div>
        </div>
      );
    }
    return "";
  }
}

export default Form1;
